import React from "react";
import ReactDOM from "react-dom";
import MainSearchBox from "./components/MainSearchBox";
import {initSentrySession} from "../../service/SentryService";
import { StyleProvider } from '../../customHooks/useStyleContext';

const rootElement = document.getElementById("search-root");
export const SectionContext = React.createContext(typeof sectionData !== 'undefined' ? sectionData : {})

initSentrySession(typeof app_env !== 'undefined' ? app_env : 'dev');

const renderApp = (Component) => {
    if (!rootElement) {
        return;
    }

    ReactDOM.render(
        <SectionContext.Provider value={typeof sectionData !== 'undefined' ? sectionData : {}}>
            <StyleProvider>
                <Component />
            </StyleProvider>
        </SectionContext.Provider>,
        rootElement
    );
};

renderApp(MainSearchBox);
